import React from 'react';

const Button = ({ onClick, children }) => {
    // children is the text
    return (
        <button type="button" onClick={onClick}>
            {children}
        </button>
    );
};

export default Button;
